import { ReactComponentManifest } from "web/entrypoints/common/setup";
import AppDownloadButton from "web/react/components/app-download-button/app-download-button";
import BannerContainer from "web/react/components/banner-container/banner-container";
import AppDownloadBanner from "web/react/components/app-download-banner/app-download-banner";
import CustomerCaptureOverlay from "web/react/components/customer-capture-overlay/customer-capture-overlay";
import Example from "web/react/components/example/example";
import MainNavigation from "web/react/components/main-navigation/main-navigation";
import MainNavigationToggleMobile from "web/react/components/main-navigation/main-navigation-toggle-mobile/main-navigation-toggle-mobile";
import RecentlyViewedEmailCapture from "web/react/components/recently-viewed-email-capture/recently-viewed-email-capture";
import SearchButton from "web/react/components/search-button/search-button";
import withRedux from "web/react/redux-provider";

/*
    Common components that are on every page (eg header)
*/
const components: ReactComponentManifest = {
    AppDownloadBanner,
    AppDownloadButton,
    BannerContainer: withRedux(BannerContainer),
    CustomerCaptureOverlay,
    Example,
    MainNavigation,
    MainNavigationToggleMobile,
    RecentlyViewedEmailCapture,
    SearchButton,
};

export default components;
